export default {"src":"/_next/static/media/gated-feedback-image.f6d77666.svg","height":561,"width":575};